import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-income-gray',
  templateUrl: './icon-income-gray.component.html',
  styles: []
})
export class IconIncomeGrayComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
